export const textpl = {
  titleHome: 'Przewodnik Bröllin (podgląd {version})',
  welcome: 'Witamy w przewodniku po Bröllin.',
  qrInfo:
    'Za pomocą przycisku <img src="{qrIcon}" style="height: 1em" /> na środku u góry możesz zeskanować kody QR na budynkach na terenie zamku Bröllin i uzyskać więcej informacji.',
  mapAlt: 'Mapa Bröllin',
  logoAlt: 'Logo',
  homeAlt: 'Strona główna',
  backAlt: 'Wstecz',
  qrAlt: 'Kod QR',
  qrScan: 'Skanuj kod QR',
  langSelectTitle: 'Wybierz język',
  langDe: 'Deutsch',
  langEn: 'English',
  langPl: 'Polski',
  close: 'Zamknij',
  navHome: 'Strona główna',
  navMenu: 'Menu',
  navStudio3: 'Studio 3',
  navStudio1: 'Studio 1',
  navStudio2: 'Studio 2',
  navMeadow: 'Łąka',
  navSheepStable: 'Owczarnia',
  navManor: 'Dwór',
  navCircusSilo: 'Cyrkowy Silo, Magazyn Krzyżowy',
  navRefectorium: 'Refektarz, Magazyn Podłużny',
  navCafe: 'Café',
  navFlorianHall: 'Hala Floriana, Suszarnia Zboża',
  navPolishGerman: 'Polsko-Niemiecki, Duża Obora',
  switchToLight: 'Przełącz na jasny motyw',
  switchToDark: 'Przełącz na ciemny motyw',
  themeAuto: 'Użyj ustawień systemowych (auto)',
  navAbout: 'O nas',
  aboutTitle: 'Więcej linków',
  aboutLinkWebsite: 'Strona broellin.de',
  aboutApp: 'Ta aplikacja https://brollin.sonabit.de',
  aboutQrAlt: 'Kod QR dla brollin.sonabit.de',
  aboutVersion: 'Wersja: {version}',
  noCodeProvided: 'Nie podano kodu.',
  noContentFound: 'Nie znaleziono treści dla kodu "{code}" w języku "{lang}".',
  noContentFoundGeneric: 'Nie znaleziono treści dla kodu "{code}".',
}
